// The server renders the latest GitHub release when it has it. If it didn't
// yet (e.g. right after startup), fill the version labels in client-side.

interface ReleaseResponse {
  release: { tag: string; dmg: { size: string } | null } | null;
}

export async function initRelease(): Promise<void> {
  const empty = Array.from(document.querySelectorAll<HTMLElement>("[data-release-label][hidden]"));
  if (!empty.length) return;
  try {
    const res = await fetch("/api/release", { headers: { Accept: "application/json" } });
    if (!res.ok) return;
    const { release } = (await res.json()) as ReleaseResponse;
    if (!release) return;
    const label = release.dmg ? `${release.tag} · ${release.dmg.size}` : release.tag;
    for (const el of empty) {
      el.textContent = label;
      el.hidden = false;
    }
  } catch {
    // Labels are optional; leave them hidden.
  }
}
